export default "__VITE_ASSET__BYevVi_B__"